export enum Platforms {
    IOS = 'ios',
    Android = 'android',
}
